import type { SchemaViewMode } from '@atlassian/jira-servicedesk-insight-urls/src/services/index.tsx';

export const VIEW_MODES: SchemaViewMode[] = ['object', 'attribute'];
export const VIEW_MODES_MAP: Record<SchemaViewMode, number> = { object: 0, attribute: 1 };
